module.exports = __webpack_public_path__ + "static/img/chat-pass.372c1be3.png";